export const ACTION_TYPES = {
    REQUEST_PROVINCES: 'REQUEST_PROVINCES',
    RECEIVE_PROVINCES: 'RECEIVE_PROVINCES'
  };
  
  const initialState = { entities: [], isLoading: false };
  
  export const provinceActions = {
    requestProvinces: () => async (dispatch) => {

      dispatch({ type: ACTION_TYPES.REQUEST_PROVINCES });
  
      const url = `api/province`;
      const response = await fetch(url);
      const entities = await response.json();
  
      dispatch({ type: ACTION_TYPES.RECEIVE_PROVINCES, entities });
    }
  };
  
  export const reducer = (state, action) => {
    state = state || initialState;
  
    switch (action.type) {
      case (ACTION_TYPES.REQUEST_PROVINCES):
        return {
          ...state,
          isLoading: true
        };
        case (ACTION_TYPES.RECEIVE_PROVINCES):
        return {
          ...state,
          isLoading: false,
          entities: action.entities
        }
      default:
        return state;
    }
  
  };
  


// WEBPACK FOOTER //
// ./src/store/Province.Reducer.js